/* global axios */

import ApiClient from '../ApiClient';

class FormsAPI extends ApiClient {
  constructor() {
    super('integrations/forms', { accountScoped: true });
  }

  getLoginLink() {
    return axios.get(`${this.url}/url`);
  }

  getFormsList() {
    return axios.get(`${this.url}/formList`);
  }

  getFormLink(formPublicId, conversationId) {
    return axios.get(`${this.url}/formLink`, {
      params: { formPublicId, conversationId },
    });
  }

  // Used from the new conversation screen, where no conversation exists yet and the contact is
  // resolved from the details typed into the To field.
  getContactFormLink(formPublicId, inboxId, contact) {
    return axios.post(`${this.url}/contactFormLink`, {
      formPublicId,
      inboxId,
      contact,
    });
  }
}

export default new FormsAPI();
